import { RolloutStateInterface } from './rollout.interface';
import { RolloutStatus } from './rollout.const';
import { DEFAULT_ROLLOUT_BEHAVIOR_SELECTION } from '../rollout-behavior/rollout-behavior.const';

/**
 * Initial state for rollout store
 * Follows the same patterns as initialWorktimeState
 */
export const initialRolloutState: RolloutStateInterface = {
  startDate: null,
  endDate: null,
  selectedBranch: null,
  selectedBranchUid: null,
  selectedReferenceLogsUId: null,
  selectedWeek: null,
  rolloutBehavior: DEFAULT_ROLLOUT_BEHAVIOR_SELECTION,
  isContributorView: false,
  loading: false,
  error: [],
  isError: false,
  status: RolloutStatus.IDLE,
  branches: [],
  validWeeks: [],
  minStartDate: null,
  maxEndDate: null,
};
